import React from 'react'

// Stepper do fluxo V2 — guia de identidade SM Direto (set/2026): faixa branca, passos
// numerados, concluídos com "check" e fio vermelho entre eles. AS ETAPAS SÃO AS DO
// FLUXO REAL (não as do protótipo do marketing): nenhuma etapa foi criada ou removida.
const STEPS = ['Voucher', 'Produtos', 'Identificação', 'Resumo', 'Conclusão']

const Check = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
)

export default function V2Stepper({ current }) {
  return (
    <div className="v2-stp" role="navigation" aria-label={`Etapa ${current + 1} de ${STEPS.length}`}>
      <ol className="v2-stepper v2-stp__in">
        {STEPS.map((name, i) => {
          const done = i < current
          const active = i === current
          return (
            <li key={name} className={`v2-stp__item${done ? ' is-done' : ''}${active ? ' is-active' : ''}`} aria-current={active ? 'step' : undefined}>
              <span className="v2-stp__dot">{done ? <Check /> : i + 1}</span>
              <span className={active ? 'v2-step-name v2-step-name--active' : 'v2-step-name'}>{name}</span>
              {i < STEPS.length - 1 ? <span className="v2-stp__bar" aria-hidden="true" /> : null}
            </li>
          )
        })}
      </ol>
    </div>
  )
}

export const STEP_COUNT = STEPS.length
